import * as Dialog from '@radix-ui/react-dialog'
import { useAppStore } from '@store'
import { useNavigate } from 'react-router-dom'
import { VisuallyHidden } from '@radix-ui/react-visually-hidden'

type ModalConfirmationTexturesProps = {
  closeModal: () => void
  text: string
  onConfirm: () => void
}

export function ModalConfirmationTextures({
  closeModal,
  text,
  onConfirm,
}: ModalConfirmationTexturesProps) {
  const navigate = useNavigate()

  function handleClickYes() {
    onConfirm()
    closeModal()
  }
  function handleClickNo() {
    closeModal()
    navigate('/planner')
  }

  return (
    <Dialog.Root open={true}>
      <Dialog.Portal>
        <Dialog.Content
          className='dialog white-background z-650 absolute left-1/2 top-1/2 h-min w-72 -translate-x-1/2 -translate-y-1/2 rounded-2xl border-2 border-C/Color3 bg-C/Color1 p-2 text-left text-xs shadow-xl'
          style={{ zIndex: 100, position: 'absolute' }}
        >
          <VisuallyHidden>
            <Dialog.Title>Confirmation</Dialog.Title>
          </VisuallyHidden>
          <div className='flex flex-col items-center justify-center gap-y-1.5'>
            <p className='text-md mt-2 text-center'>{text} </p>
            <div className='button container mb-2 mt-2 flex w-full justify-center gap-3'>
              <button
                id='yes'
                onClick={handleClickYes}
                className='flex cursor-pointer items-center rounded-xl bg-C/Color3 px-3 text-xs font-normal text-C/Color1'
              >
                {'Sí'}
              </button>
              <button
                id='no'
                onClick={handleClickNo}
                className='flex cursor-pointer items-center rounded-xl border border-solid border-C/Color7 bg-C/Color5 px-3 py-0.5 text-xs font-normal text-C/Color1'
              >
                {'No'}
              </button>
            </div>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
